import { render } from "./landing.vue?vue&type=template&id=7a22a61e"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"

import exportComponent from "/home/apps/ru_dklimanov/production/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__